module.exports = __webpack_public_path__ + "img/shop-5.cc91b04a.jpg";